export default __webpack_public_path__ + "static/media/martin_mercadopago.22b1be5a.jpg";